import { Checkbox } from 'common/form';
import React from 'react';

type Props = {
  value: boolean;
  onChange: (value: any) => void;
};

export const OverrideLockCandidatesCheckbox: React.FC<Props> = ({
  value,
  onChange
}) => {
  return (
    <Checkbox
      field={{
        checkboxLabel: 'Override locked applicant statuses',
        containerSx: {
          m: 0,
          ml: 0.2 // align checkbox
        }
      }}
      value={value}
      onChange={(value) => {
        onChange(value);
      }}
    />
  );
};
